import type { CartArticleData } from '@hub/bearing-hub/common/basket/useAddToShoppingCart';
import { Icon, IconColor, IconID } from '@hub/common/Icon/Icon';
import { useTranslation } from 'next-i18next';
import type { IbhShape } from '@igus/iglidur-bearing-hub-api';

type BasketToastSuccessContentType = {
  articleData: CartArticleData;
  shape: IbhShape;
};
export const BasketToastSuccessContent = ({ articleData, shape }: BasketToastSuccessContentType) => {
  const { t } = useTranslation(['common']);
  const { quantity, material, unitPrice, totalPrice } = articleData;
  return (
    <div className="flex flex-row items-center" data-testid="add-to-basket-success-toast">
      <div className="mr-4">
        <Icon size={9} id={IconID.INFO_CIRCLE_MODERN_FILLED} color={IconColor.WHITE} />
      </div>

      <div className="flex-col">
        <p className="mb-2 font-normal text-xl">
          {t('NOTIFICATION.ADD_TO_CART_SUCCESS', {
            quantity,
            material: material.name,
            shape: t(`SHAPES.${shape}.SHAPE_MENU`, { ns: 'bearing-hub/bearingHub' }),
            ns: 'bearing-hub/bearingHub',
          })}
        </p>
        {unitPrice.value !== -1 && (
          <>
            <p className="font-semibold text-xl">
              {unitPrice.value.toFixed(2)} {unitPrice.unit}/
              {t('NOTIFICATION.UNIT_PRICE', { ns: 'bearing-hub/bearingHub' })}
            </p>
            <p className="font-semibold text-xl">
              {totalPrice.value.toFixed(2)} {totalPrice.unit}/
              {t('NOTIFICATION.TOTAL_PRICE', { ns: 'bearing-hub/bearingHub' })}
            </p>
          </>
        )}
      </div>
    </div>
  );
};
